import {createSlice} from "@reduxjs/toolkit";

const initialEventInfosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  eventInfoForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const eventInfosSlice = createSlice({
  name: "eventInfos",
  initialState: initialEventInfosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getEventInfoById
    eventInfoFetched: (state, action) => {
      state.actionsLoading = false;
      state.eventInfoForEdit = action.payload.eventInfoForEdit;
      state.error = null;
    },
    // findEventInfos
    eventInfosFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createEventInfo
    eventInfoCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.eventInfo);
    },
    // updateEventInfo
    eventInfoUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.eventInfoId === action.payload.eventInfo.eventInfoId) {
          return action.payload.eventInfo;
        }
        return entity;
      });
    },
    // deleteEventInfo
    eventInfoDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.eventInfoId !== action.payload.eventInfoId);
    },
    // deleteEventInfos
    eventInfosDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.eventInfoId)
      );
    },
  }
});
